import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58c511ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk_add_prestas" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Vos entreprises", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Ajouter une Entreprise", -1))
const _hoisted_4 = { class: "double" }
const _hoisted_5 = { class: "form_container" }
const _hoisted_6 = { class: "quadra" }
const _hoisted_7 = { class: "double" }
const _hoisted_8 = { class: "form_container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Horaires ouverture", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Mettre 00:00 si fermé (voir exemple du samedi pour une demi journée, dimanche pour une journée)", -1))
const _hoisted_11 = { class: "penta" }
const _hoisted_12 = { class: "horaires" }
const _hoisted_13 = { class: "switch" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Pause le midi", -1))
const _hoisted_16 = { class: "horaires" }
const _hoisted_17 = { class: "switch" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Pause le midi", -1))
const _hoisted_20 = { class: "horaires" }
const _hoisted_21 = { class: "switch" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Pause le midi", -1))
const _hoisted_24 = { class: "horaires" }
const _hoisted_25 = { class: "switch" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Pause le midi", -1))
const _hoisted_28 = { class: "horaires" }
const _hoisted_29 = { class: "switch" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Pause le midi", -1))
const _hoisted_32 = { class: "horaires" }
const _hoisted_33 = { class: "switch" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Pause le midi", -1))
const _hoisted_36 = { class: "horaires" }
const _hoisted_37 = { class: "switch" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Pause le midi", -1))
const _hoisted_40 = { class: "form_container" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Services que vous proposez", -1))
const _hoisted_42 = { class: "data-cards" }
const _hoisted_43 = { class: "card-icon" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Ajouter une entreprise")
], -1))
const _hoisted_45 = { class: "card-logo" }
const _hoisted_46 = ["src", "alt"]
const _hoisted_47 = { class: "info" }

import { onBeforeMount, onMounted } from 'vue'
import { ref } from "vue";
import axios from "axios";
import { toast } from 'vue3-toastify';
import autoComplete from '../inputs/autoComplete.vue'
import { useAdminStore } from '../../store/piniaAdmin'
import { useLoginStore } from '../../store/piniaLogin'
import PlusCircleOutlineIcon from 'vue-material-design-icons/PlusCircleOutline.vue';
import { LMap, LTileLayer, LMarker } from "@vue-leaflet/vue-leaflet";

export default /*#__PURE__*/_defineComponent({
  __name: 'mesPrestationsView',
  setup(__props) {

const store = useAdminStore()


const storeLogin = useLoginStore()


// variable
const distMax = ref(40);
const mainCategoriesSharp = ref([]);
const serviceCat = ref();
const servicesList = ref([]);
const entreprises = ref([]);
const allServices = ref([]);
const mainCategories = ref([]);
const horaires = ref({ lp: false, mp: false, mep: false, jp: false, vp: false, sp: true, dp: false });
const is_map_active = ref(false);
const prestaFormVisible = ref(false);
const services = ref([]);
const urlServer = ref(process.env.VUE_APP_SERVER_URL);
const userData = ref(JSON.parse(storeLogin.currentUser));
const contact = ref({ lat: userData.value.location.coordinates[1], long: userData.value.location.coordinates[0] });



function activeForm() {
    prestaFormVisible.value = true;
    console.log(prestaFormVisible.value);

}
function addService() {
    servicesList.value.push({ prix: 0, type: "", service: { titre: '', is_new: false }, })

}
function checkAdress() {

    is_map_active.value = false;
    axios.get(`https://dev.virtualearth.net/REST/v1/Locations/FR/${contact.value.codePostale}/${contact.value.ville}/${contact.value.adresse}?key=AoDJrgfVItWTs_icYLtdaizY88Uv3yj-98Tr03Cr6TR1VONQwP3tPZw0EY-JWTaL`)
        .then(function (response) {
            // handle success

            contact.value.lat = response.data.resourceSets[0].resources[0].point.coordinates[0];
            contact.value.long = response.data.resourceSets[0].resources[0].point.coordinates[1];
            is_map_active.value = true;

        })
        .catch(function (error) {
            is_map_active.value = true;

            // handle error
            console.log(error);
        })

}
async function addEntreprise(values) {
    const form = new FormData();

    form.append('name', values.form_presta.stepTwo.logo[0].name);
    values.form_presta.stepTwo.logo.forEach((fileItem) => {
        form.append('logo', fileItem.file)
    })
    values.form_presta.stepTwo.images.forEach((fileItem) => {
        form.append('images', fileItem.file)
    })

    const result = {};
    result.userId = userData.value._id;
    result.nomEntreprise = values.form_presta.stepOne.nomEntreprise;
    result.presentation = values.form_presta.stepTwo.presentation;
    result.shortPresentation = values.form_presta.stepTwo.shortPresentation;
    result.contact = contact.value;
    result.categories = serviceCat.value;
    result.distMax = values.form_presta.stepTwo.distMax;
    result.prixMiniDevis = values.form_presta.stepTwo.prixMiniDevis;
    result.siret = values.form_presta.stepTwo.siret;
    result.coordone = { lat: contact.value.lat, long: contact.value.long };
    result.servicesPresta = servicesList.value.filter((objet) => {
        return objet.service.titre !== "";
    });
    result.horaires = {
        lundi: checkDate(horaires.value.lmd, horaires.value.lmf, horaires.value.lad, horaires.value.laf),
        mardi: checkDate(horaires.value.mmd, horaires.value.mmf, horaires.value.mad, horaires.value.maf),
        mercredi: checkDate(horaires.value.memd, horaires.value.memf, horaires.value.mead, horaires.value.meaf),
        jeudi: checkDate(horaires.value.jmd, horaires.value.jmf, horaires.value.jad, horaires.value.jaf),
        vendredi: checkDate(horaires.value.vmd, horaires.value.vmf, horaires.value.vad, horaires.value.vaf),
        samedi: checkDate(horaires.value.smd, horaires.value.smf, horaires.value.sad, horaires.value.saf),
        dimanche: checkDate(horaires.value.dmd, horaires.value.dmf, horaires.value.dad, horaires.value.daf),
    };
    form.append('datas', JSON.stringify(result));
    console.log(form);

    await axios.post(process.env.VUE_APP_SERVER_URL + '/prestataires', form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then(function (response) {
            userData.value.entreprises.push(response.data._id)
            storeLogin.setUser(userData.value)
            toast.success("Votre entreprise viens d'étre créée!");

        })
        .catch(function (error) {
            toast.error(error);
        });

    // regler les horaires puis envoyer au serveur
    this.$formkit.reset('rk_addpresta_form')
}

function checkDate(md, mf, ad, af) {
    let matin = '';
    let aprem = '';
    console.log(md, mf, ad, af);

    if (mf == null && ad == null) {
        if (md == "00:00" && af == "00:00") {
            matin = 'Fermé';
            aprem = 'Fermé';
        } else {
            matin = md;
            aprem = af;
        }

    } else {
        if (md == "00:00" && mf == "00:00") {
            matin = 'Fermé';
        } else {
            matin = md + ' - ' + mf;
        }
        if (ad == "00:00" && af == "00:00") {
            aprem = 'Fermé';


        } else {
            aprem = ad + ' - ' + af;
        }


    }
    return { m: matin, a: aprem };

}


// function selectElem(catSelected) {
//     serviceCat.value = catSelected._id;
//     axios.get(process.env.VUE_APP_SERVER_URL + '/services/cat', {
//         params: {
//             cat: catSelected._id
//         }
//     })
//         .then(function (response) {
//             // handle success
//             allServices.value = response.data;
//         })
//         .catch(function (error) {
//             // handle error
//             toast.error(error);
//         })
// }
onMounted(async () => {
    console.log(contact.value);

    is_map_active.value = true;
})

onBeforeMount(async () => {
    // axios.get(process.env.VUE_APP_SERVER_URL + '/categories')
    //     .then(function (response) {
    //         // handle success
    //         categories.value = response.data;
    //         console.log(categories.value);
    //     })
    //     .catch(function (error) {
    //         // handle error
    //         toast.error(error);
    //     })

    mainCategoriesSharp.value = await axios.get(process.env.VUE_APP_SERVER_URL + '/categories')
        .then(function (response) {
            // handle success
            mainCategories.value = response.data;


            store.setCategories(response.data)
            const categoriesSharp = [];
            mainCategories.value.forEach(element => {
                if (element.titre !== 'Bénévolat' && element.titre !== 'Prestation') {

                    categoriesSharp.push({ label: element.titre, value: element._id });
                }
            });
            return categoriesSharp;
        })
        .catch(function (error) {
            // handle error
            toast.error(error);
        })
    axios.get(process.env.VUE_APP_SERVER_URL + '/services')
        .then(function (response) {
            // handle success

            allServices.value = response.data;

        })
        .catch(function (error) {
            // handle error
            toast.error(error);
        })


    if (userData.value.entreprises.length > 0) {

        axios.get(process.env.VUE_APP_SERVER_URL + '/prestataires/my', {
            params: {
                myPrestas: userData.value.entreprises
            }
        })
            .then(function (response) {
                // handle success
                entreprises.value = response.data;


            })
            .catch(function (error) {
                // handle error
                toast.error(error);
            })
    }

})

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["add_presta_form", { active: prestaFormVisible.value }])
    }, [
      _createVNode(_component_FormKit, {
        type: "form",
        id: "rk_addpresta_form",
        "submit-label": "Ajouter une Entreprise",
        onSubmit: addEntreprise
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_FormKit, {
            type: "multi-step",
            "valid-step-icon": "check",
            name: "form_presta",
            "tab-style": "progress",
            "allow-incomplete": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormKit, {
                type: "step",
                name: "stepOne",
                label: "Contact"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormKit, {
                    name: "nomEntreprise",
                    "floating-label": true,
                    label: "Nom de l'entreprise"
                  }),
                  _createVNode(_component_FormKit, {
                    type: "group",
                    modelValue: contact.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contact).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_FormKit, {
                          type: "email",
                          "floating-label": true,
                          label: "Adresse email",
                          name: "email",
                          validation: "required|email",
                          "validation-visibility": "live"
                        }),
                        _createVNode(_component_FormKit, {
                          type: "tel",
                          "floating-label": true,
                          name: "tel",
                          label: "Numéro de téléphone",
                          placeholder: "0xxxxxxxxx",
                          validation: "matches:/^[0-9]{10}$/",
                          "validation-messages": {
                                        matches: 'Numéro non valide',
                                    },
                          "validation-visibility": "dirty"
                        }),
                        _createVNode(_component_FormKit, {
                          type: "url",
                          label: "Site internet",
                          "floating-label": true,
                          name: "site",
                          placeholder: "https://www.example.com...",
                          validation: "url"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_FormKit, {
                            name: "adresse",
                            "floating-label": true,
                            label: "Adresse de l'entreprise",
                            help: "Cette adresse servira à vous retrouver localement"
                          }),
                          _createVNode(_component_FormKit, {
                            name: "codePostale",
                            "floating-label": true,
                            label: "Code postal"
                          }),
                          _createVNode(_component_FormKit, {
                            name: "ville",
                            "floating-label": true,
                            label: "Ville"
                          }),
                          _createVNode(_component_FormKit, {
                            type: "button",
                            onClick: checkAdress
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Verifier mon adresse ")
                            ]),
                            _: 1
                          })
                        ]),
                        (is_map_active.value)
                          ? (_openBlock(), _createBlock(_unref(LMap), {
                              key: 0,
                              ref: "map",
                              zoom: 11,
                              center: [contact.value.lat, contact.value.long]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(LTileLayer), {
                                  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                                  "layer-type": "base",
                                  name: "OpenStreetMap"
                                }),
                                _createVNode(_unref(LMarker), {
                                  "lat-lng": [contact.value.lat, contact.value.long]
                                }, null, 8, ["lat-lng"])
                              ]),
                              _: 1
                            }, 8, ["center"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_FormKit, {
                type: "step",
                name: "stepTwo",
                label: "Fiche entreprise"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormKit, {
                    name: "presentation",
                    type: "textarea",
                    label: "Présenter l'entreprise",
                    rows: "20",
                    placeholder: "Entreprise crée ...",
                    help: "Pensez à utiliser un maximum de mots-clés et à mentionner clairement votre métier "
                  }),
                  _createVNode(_component_FormKit, {
                    name: "shortPresentation",
                    maxlength: "80",
                    type: "textarea",
                    label: "Présentation courte de l'entreprise",
                    rows: "10",
                    placeholder: "Entreprise crée ...",
                    help: "Cette présentation sera visible sur les vignettes"
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_FormKit, {
                      name: "logo",
                      validation: "required",
                      type: "file",
                      label: "Votre Logo",
                      accept: "image/*"
                    }),
                    _createVNode(_component_FormKit, {
                      name: "images",
                      type: "file",
                      label: "Images de présentations",
                      help: "Nous vous conseillons d'en mettre 4 minimum",
                      multiple: "true",
                      accept: "image/*"
                    }),
                    _createVNode(_component_FormKit, {
                      name: "distMax",
                      modelValue: distMax.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((distMax).value = $event)),
                      type: "range",
                      hidden: "",
                      label: 'Distance maximum de votre activité : ' + distMax.value + ' Km',
                      min: "0",
                      max: "40"
                    }, null, 8, ["modelValue", "label"]),
                    _createVNode(_component_FormKit, {
                      hidden: "",
                      type: "number",
                      help: "Vous recevrez les demandes de devis qui sont supérieures ou égal à ce prix",
                      label: "Prix de devis minimum",
                      name: "prixMiniDevis",
                      value: "0",
                      step: "1"
                    }),
                    _createVNode(_component_FormKit, {
                      name: "siret",
                      label: "Siret/Siren de l'entreprise"
                    }),
                    _createVNode(_component_FormKit, {
                      type: "number",
                      hidden: "",
                      label: "Nombres de personnes dans l'entreprise (approximatif)",
                      name: "nbSalaries",
                      value: "0",
                      step: "1"
                    }),
                    _createVNode(_component_FormKit, {
                      modelValue: serviceCat.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((serviceCat).value = $event)),
                      type: "taglist",
                      validation: "required",
                      name: "categories",
                      label: "Votre/vos secteur(s) d'activité(s)",
                      options: mainCategoriesSharp.value,
                      "empty-message": "Catégorie non répertoriée"
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_FormKit, {
                type: "step",
                name: "stepThree",
                label: "Horaires d'ouverture"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_FormKit, {
                      type: "group",
                      modelValue: horaires.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((horaires).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_FormKit, {
                              name: "lmd",
                              type: "time",
                              value: "08:00",
                              label: "Lundi Matin Début"
                            }),
                            (horaires.value.lp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  name: "lmf",
                                  type: "time",
                                  value: "12:00",
                                  label: "Lundi Matin Fin"
                                }))
                              : _createCommentVNode("", true),
                            (horaires.value.lp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 1,
                                  name: "lad",
                                  type: "time",
                                  value: "13:00",
                                  label: "Lundi Après-midi Début"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FormKit, {
                              name: "laf",
                              type: "time",
                              value: "18:00",
                              label: "Lundi Après-midi Fin"
                            }),
                            _createElementVNode("label", _hoisted_13, [
                              _withDirectives(_createElementVNode("input", {
                                id: "pause_lp",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((horaires.value.lp) = $event)),
                                type: "checkbox"
                              }, null, 512), [
                                [_vModelCheckbox, horaires.value.lp]
                              ]),
                              _hoisted_14,
                              _hoisted_15
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_FormKit, {
                              name: "mmd",
                              type: "time",
                              value: "08:00",
                              label: "Mardi Matin Début"
                            }),
                            (horaires.value.mp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  name: "mmf",
                                  type: "time",
                                  value: "12:00",
                                  label: "Mardi Matin Fin"
                                }))
                              : _createCommentVNode("", true),
                            (horaires.value.mp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 1,
                                  name: "mad",
                                  type: "time",
                                  value: "13:00",
                                  label: "Mardi Après-midi Début"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FormKit, {
                              name: "maf",
                              type: "time",
                              value: "18:00",
                              label: "Mardi Après-midi Fin"
                            }),
                            _createElementVNode("label", _hoisted_17, [
                              _withDirectives(_createElementVNode("input", {
                                id: "pause_mep",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((horaires.value.mp) = $event)),
                                type: "checkbox"
                              }, null, 512), [
                                [_vModelCheckbox, horaires.value.mp]
                              ]),
                              _hoisted_18,
                              _hoisted_19
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_FormKit, {
                              name: "memd",
                              type: "time",
                              value: "08:00",
                              label: "Mercredi Matin Début"
                            }),
                            (horaires.value.mep)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  name: "memf",
                                  type: "time",
                                  value: "12:00",
                                  label: "Mercredi Matin Fin"
                                }))
                              : _createCommentVNode("", true),
                            (horaires.value.mep)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 1,
                                  name: "mead",
                                  type: "time",
                                  value: "13:00",
                                  label: "Mercredi Après-midi Début"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FormKit, {
                              name: "meaf",
                              type: "time",
                              value: "18:00",
                              label: "Mercredi Après-midi Fin"
                            }),
                            _createElementVNode("label", _hoisted_21, [
                              _withDirectives(_createElementVNode("input", {
                                id: "pause_mep",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((horaires.value.mep) = $event)),
                                type: "checkbox"
                              }, null, 512), [
                                [_vModelCheckbox, horaires.value.mep]
                              ]),
                              _hoisted_22,
                              _hoisted_23
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_FormKit, {
                              name: "jmd",
                              type: "time",
                              value: "08:00",
                              label: "Jeudi Matin Début"
                            }),
                            (horaires.value.jp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  name: "jmf",
                                  type: "time",
                                  value: "12:00",
                                  label: "Jeudi Matin Fin"
                                }))
                              : _createCommentVNode("", true),
                            (horaires.value.jp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 1,
                                  name: "jad",
                                  type: "time",
                                  value: "13:00",
                                  label: "Jeudi Après-midi Début"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FormKit, {
                              name: "jaf",
                              type: "time",
                              value: "18:00",
                              label: "Jeudi Après-midi Fin"
                            }),
                            _createElementVNode("label", _hoisted_25, [
                              _withDirectives(_createElementVNode("input", {
                                id: "pause_jp",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((horaires.value.jp) = $event)),
                                type: "checkbox"
                              }, null, 512), [
                                [_vModelCheckbox, horaires.value.jp]
                              ]),
                              _hoisted_26,
                              _hoisted_27
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_FormKit, {
                              name: "vmd",
                              type: "time",
                              value: "08:00",
                              label: "Vendredi Matin Début"
                            }),
                            (horaires.value.vp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  name: "vmf",
                                  type: "time",
                                  value: "12:00",
                                  label: "Vendredi Matin Fin"
                                }))
                              : _createCommentVNode("", true),
                            (horaires.value.vp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 1,
                                  name: "vad",
                                  type: "time",
                                  value: "13:00",
                                  label: "Vendredi Après-midi Début"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FormKit, {
                              name: "vaf",
                              type: "time",
                              value: "18:00",
                              label: "Vendredi Après-midi Fin"
                            }),
                            _createElementVNode("label", _hoisted_29, [
                              _withDirectives(_createElementVNode("input", {
                                id: "pause_lp",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((horaires.value.vp) = $event)),
                                type: "checkbox"
                              }, null, 512), [
                                [_vModelCheckbox, horaires.value.vp]
                              ]),
                              _hoisted_30,
                              _hoisted_31
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createVNode(_component_FormKit, {
                              name: "smd",
                              type: "time",
                              label: "Samedi Matin Début",
                              value: "08:00"
                            }),
                            (horaires.value.sp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  name: "smf",
                                  type: "time",
                                  label: "Samedi Matin Fin",
                                  value: "12:00"
                                }))
                              : _createCommentVNode("", true),
                            (horaires.value.sp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 1,
                                  name: "sad",
                                  type: "time",
                                  label: "Samedi Après-midi Début",
                                  value: "00:00"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FormKit, {
                              name: "saf",
                              type: "time",
                              label: "Samedi Après-midi Fin",
                              value: "00:00"
                            }),
                            _createElementVNode("label", _hoisted_33, [
                              _withDirectives(_createElementVNode("input", {
                                id: "pause_sp",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((horaires.value.sp) = $event)),
                                type: "checkbox"
                              }, null, 512), [
                                [_vModelCheckbox, horaires.value.sp]
                              ]),
                              _hoisted_34,
                              _hoisted_35
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_FormKit, {
                              name: "dmd",
                              type: "time",
                              label: "Dimanche Matin Début",
                              value: "00:00"
                            }),
                            (horaires.value.dp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  name: "dmf",
                                  type: "time",
                                  label: "Dimanche Matin Fin",
                                  value: "00:00"
                                }))
                              : _createCommentVNode("", true),
                            (horaires.value.dp)
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 1,
                                  name: "dad",
                                  type: "time",
                                  label: "Dimanche Après-midi Début",
                                  value: "00:00"
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FormKit, {
                              name: "daf",
                              type: "time",
                              label: "Dimanche Après-midi Fin",
                              value: "00:00"
                            }),
                            _createElementVNode("label", _hoisted_37, [
                              _withDirectives(_createElementVNode("input", {
                                id: "pause_lp",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((horaires.value.dp) = $event)),
                                type: "checkbox"
                              }, null, 512), [
                                [_vModelCheckbox, horaires.value.dp]
                              ]),
                              _hoisted_38,
                              _hoisted_39
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_FormKit, {
                type: "step",
                name: "stepFour",
                label: "Vos services"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormKit, {
                    type: "group",
                    modelValue: services.value,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((services).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(servicesList.value, (service, indexService) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "single_service",
                            key: indexService
                          }, [
                            (servicesList.value[indexService].service.titre !== '')
                              ? (_openBlock(), _createBlock(_component_FormKit, {
                                  key: 0,
                                  label: "Nom du service",
                                  value: servicesList.value[indexService].service.titre
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true),
                            (service.service.titre == '')
                              ? (_openBlock(), _createBlock(autoComplete, {
                                  key: 1,
                                  label: "Service proposé",
                                  type: "Services",
                                  onItemSelected: (n) => servicesList.value[indexService].service = n
                                }, null, 8, ["onItemSelected"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_FormKit, {
                              type: "select",
                              label: "prix / ",
                              modelValue: servicesList.value[indexService].type,
                              "onUpdate:modelValue": ($event: any) => ((servicesList.value[indexService].type) = $event),
                              options: [
                                            'Prestation',
                                            'Heure',
                                            'Jour',
                                            'Mois',
                                            'Sur devis',
                                        ]
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _withDirectives(_createVNode(_component_FormKit, {
                              type: "number",
                              label: "Coût du service",
                              modelValue: servicesList.value[indexService].prix,
                              "onUpdate:modelValue": ($event: any) => ((servicesList.value[indexService].prix) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]), [
                              [_vShow, servicesList.value[indexService].type !== 'Sur devis']
                            ])
                          ]))
                        }), 128)),
                        _createVNode(_component_FormKit, {
                          "prefix-icon": "add",
                          type: "button",
                          help: "Nous vous conseillons de favoriser les services déjà disponibles dans la recherche",
                          onClick: addService
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Ajouter un service ")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", {
        class: "card",
        onClick: activeForm
      }, [
        _createElementVNode("div", _hoisted_43, [
          _createVNode(PlusCircleOutlineIcon)
        ]),
        _hoisted_44
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(entreprises.value, (entreprise, indexEntreprise) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          to: `/presta/${entreprise.slug}`,
          class: "card",
          router: "",
          key: indexEntreprise
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("img", {
                src: urlServer.value + entreprise.logo,
                alt: entreprise.nomEntreprise
              }, null, 8, _hoisted_46)
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("p", null, _toDisplayString(entreprise.nomEntreprise), 1)
            ])
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
}
}

})